export default __webpack_public_path__ + "static/event-icon-5566164f9d8daebe5f8efce025fa34d2.gif";